export const openModalMeditation = () => (dispatch) => dispatch({
  type: 'OPEN_MODAL',
  modal: 'meditation',
})

export const closeModal = () => (dispatch) => dispatch({
  type: 'OPEN_MODAL',
  modal: null,
})
